var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#support_svg__clip0_1600_13967)",
    fill: "#FF7D6B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.356 2.65H9.859a2.647 2.647 0 00-2.644 2.645v3.173h-4.57A2.647 2.647 0 000 11.112v5.484c0 1.201.804 2.217 1.902 2.539v2.473a.742.742 0 001.225.562l3.414-2.93h6.258a2.647 2.647 0 002.644-2.643v-1.615h2.383l3.707 3.433a.741.741 0 001.245-.545v-2.922A2.648 2.648 0 0025 12.338V5.295a2.647 2.647 0 00-2.644-2.644zM13.96 16.597c0 .64-.521 1.161-1.161 1.161H6.266a.742.742 0 00-.483.179l-2.397 2.058v-1.495a.742.742 0 00-.742-.742c-.64 0-1.16-.52-1.16-1.16v-5.485c0-.64.52-1.16 1.16-1.16h4.571v2.386a2.647 2.647 0 002.644 2.644h4.1v1.614zm9.556-4.258c0 .64-.52 1.16-1.16 1.16h-.32a.742.742 0 00-.741.742v1.932l-2.674-2.476a.742.742 0 00-.504-.197H9.86c-.64 0-1.16-.521-1.16-1.161V5.295c0-.64.52-1.16 1.16-1.16h12.497c.64 0 1.16.52 1.16 1.16v7.043z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.412 6.715h-8.608a.742.742 0 000 1.483h8.608a.742.742 0 100-1.483zM20.412 9.78h-8.608a.742.742 0 000 1.484h8.608a.742.742 0 100-1.484z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "support_svg__clip0_1600_13967"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h25v25H0z"
  })))));
}
export default SvgSupport;